$('.sidebar-item').click(function(){
  if(!$(this).hasClass('current')){
  $(this).siblings().removeClass('current');
  $(this).addClass('current');
  }
  });


  $('.item').click(function(){
    if(!$(this).hasClass('current-item')){
    $(this).siblings().removeClass('current-item');
    $(this).addClass('current-item');
    }
    });

